import { useMemo } from 'react';

import { buildIntegrationsMetadata, type IntegrationMetadata } from '@/lib/integrations-constants';
import { useEffectiveBranding } from '@/hooks/use-effective-branding';

export const useIntegrationsMetadata = (): IntegrationMetadata[] => {
  const brand = useEffectiveBranding();
  return useMemo(() => buildIntegrationsMetadata(brand), [brand]);
};
